"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.string.sub.js");

require("regenerator-runtime/runtime.js");

var _slicedToArray2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _market = require("@/model/exchange/market.js");

var _orderDetails = _interopRequireDefault(require("../../../bill-center/components/orderDetails.vue"));

var _index = require("@/model/exchange/index");

var _order = require("@/model/contractExchange/order.js");

var _InputNumber = _interopRequireDefault(require("@/components/common/InputNumber"));

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _index2 = require("@/utils/index.js");

var _vuex = require("vuex");

var _message = require("@/components/dialog/message.js");

var Account = _interopRequireWildcard(require("@/model/user/account"));

var _settings = require("@/model/settings");

var _keymap = require("@/assets/js/keymap.js");

var _digital = require("@/assets/js/digital");

var _i18n = require("@/assets/js/i18n");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _index3 = require("@/model/contractExchange/index");

var _stationSetting = require("@/assets/js/stationSetting");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _socket = _interopRequireDefault(require("@/assets/js/socket.js"));

var _index4 = require("@/model/assets/index");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_commonMixin.default],
  data: function data() {
    return {
      tt: {},
      lockReconnect: false,
      planOrderList_create_time: "",
      planOrderList_symbol_id: "",
      planOrderList_open_side: "",
      ctimeAndEtime: [],
      ctimeAndEtime4History: [],
      open_side_array: [{
        value: 1,
        label: "买涨"
      }, {
        value: 2,
        label: "买跌"
      }],
      create_time_array: [{
        value: 86400,
        label: "今天"
      }, {
        value: 7 * 86400,
        label: "7天"
      }, {
        value: 30 * 86400,
        label: "1月"
      }, {
        value: 3 * 30 * 86400,
        label: "3月"
      }],
      isDestoryWS: false,
      coinData: {},
      assetsInfo: {
        remain: {
          all_u_valuation: {
            usdt: "--"
          },
          list: []
        }
      },
      marketList: [],
      wsContentTime: 0,
      wsUrl: "",
      tableDataComputed: [],
      // orderLoading: true,
      // row_swap_symbol_id: this.swap_symbol_id,
      contract_plan_num: 0,
      contract_position_num: 0,
      contract_multiple_num: "",
      plan_order_id: "",
      hidenCancelChecked: false,
      checked: false,
      layout: "total, prev, pager, next",
      symbolId: "",
      bail_number: "",
      contractMultipleNum: {},
      apiAssetsInfo: {},
      ///////////////////////////
      rowData: {},
      row_swap_symbol_id: "",
      inputProfitPrice: "",
      inputLossPrice: "",
      dialogVisible: false,
      appendMoneydialog: false,
      setProfitPricedialog: false,
      position_order_id: "",
      beforeBailNumber: "",
      afterBailNumber: "--",
      beforeLiquidationPrice: "",
      afterLiquidationPrice: "--",
      price_precision: "",
      dialogType: "",
      confirmMessage: "是否确认平仓此订单？",
      closePositionTypeMaps: _keymap.closePositionTypeMaps,
      currIndexPosition: 1,
      tabListPosition: [{
        value: "1",
        label: "持仓"
      }, {
        value: "2",
        label: "当前委托"
      }, {
        value: "3",
        label: "历史委托"
      }, {
        value: "4",
        label: "平仓记录"
      }],
      tableData: [],
      symbolList: {},
      coinInfoMap: {},
      triggerSideMap: {
        1: "大于触发价",
        2: "小于触发价"
      },
      tradeMap: {
        1: "市价",
        2: "限价"
      },
      sideMap: {
        1: "买涨",
        2: "买跌"
      },
      statusMap: {
        0: "未成交",
        1: "待成交",
        2: "完全成交",
        3: "已撤销",
        4: "失败"
      },
      // dataList: [],
      // historyPositionDataList: [],
      tableLoading: true,
      historytableLoading: false,
      pageInfo: {
        pageCount: 0,
        pageTotal: 0,
        pageSize: 10,
        pageCurrent: 1
      },
      from_symbol: "",
      to_symbol: "USDT",
      from_item_id: "",
      to_item_id: ""
    };
  },
  components: {
    NoData: _NoData.default,
    InputNumber: _InputNumber.default,
    OrderDetails: _orderDetails.default
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var tempCookies, _yield$Account$getUse, userInfo;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              tempCookies = _jsCookie.default.get("topcredit_exchange_t");

              if (!(tempCookies == undefined)) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return _this.initURL();

            case 4:
              _this.initWs();

              _context.next = 11;
              break;

            case 7:
              _this.token = _jsCookie.default.get("topcredit_exchange_t");
              _context.next = 10;
              return _this.initURL();

            case 10:
              _this.initWs();

            case 11:
              _context.next = 13;
              return _this.getItemList();

            case 13:
              _context.next = 15;
              return _this.getCoinInfoMap();

            case 15:
              _context.next = 17;
              return _this.getTradePairList();

            case 17:
              _this.getOrderNumber();

              _this.getAssets();

              _context.next = 21;
              return Account.getUserInfo();

            case 21:
              _yield$Account$getUse = _context.sent;
              userInfo = _yield$Account$getUse.userInfo;

              if (userInfo) {
                _this.initData(_this.checked); // this.startTimer();

              }

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    language: "user/language",
    systemCurrency: "user/currency"
  })), {}, {
    marketInfoShow: function marketInfoShow() {
      var _this2 = this;

      var marketInfo = {
        last: "",
        currency: {
          cny: ""
        }
      };
      this.marketList.forEach(function (ele) {
        if (ele.symbol_id == _this2.swap_symbol_id) {
          marketInfo = ele;
        }
      });
      return marketInfo;
    },
    rowMarketInfoShow: function rowMarketInfoShow() {
      var _this3 = this;

      var marketInfo = {
        last: "",
        currency: {
          cny: ""
        }
      };
      this.marketList.forEach(function (ele) {
        if (ele.symbol_id == _this3.row_swap_symbol_id) {
          marketInfo = ele;
        }
      });
      return marketInfo;
    },
    // 现有U资产
    assetsInfoShow: function assetsInfoShow() {
      var _this4 = this;

      var tempObj = "0";

      if (JSON.stringify(this.assetsInfo) != "{}" && this.assetsInfo.remain.list.length > 0) {
        this.assetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this4.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else if (JSON.stringify(this.apiAssetsInfo) != "{}" && this.apiAssetsInfo.remain.list.length > 0) {
        this.apiAssetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this4.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else {
        tempObj = "--";
      }

      return tempObj;
    },
    afterLiquidationPriceShow: function afterLiquidationPriceShow() {
      // 强平价 = 开仓价 - (1 做多 | -1做空)) ×(保证金 × (1 − 强平⻛险率) - 平仓手续费-开仓手续费)/持仓数量
      var tempValue = "";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.bail_number != "") {
        tempValue = this.rowData.open_price - tempSide * (this.afterBailNumberShow * (1 - this.symbolList[this.swap_symbol_id].liquidation_risk_rate / 10000) - this.rowData.close_position_fee - this.rowData.open_position_fee) / this.rowData.open_interest;

        if (this.rowData.open_side == 1) {
          //做多 做多的时候小数位用全进
          tempValue = (Math.ceil(tempValue * Math.pow(10, this.price_precision)) / Math.pow(10, this.price_precision)).toFixed(this.price_precision);
        } else {
          // 做空的时候用截断
          tempValue = tempValue.toString().substring(0, tempValue.toString().indexOf(".") + this.price_precision + 1);
        }
      } else {
        tempValue = this.afterLiquidationPrice;
      }

      if (Number(tempValue) < 0) {
        tempValue = "0";
      }

      return tempValue;
    },
    afterBailNumberShow: function afterBailNumberShow() {
      return (Number(this.afterBailNumber) + Number(this.bail_number)).toFixed(2);
    },
    // 平仓盈亏 = (inputProfitPrice-开仓价) × (1 做多 | -1做空)) × 持仓数量  - 平仓手续费
    expectedProfit: function expectedProfit() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputProfitPrice != "" && Number(this.inputProfitPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndexPosition == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = (Number(this.inputProfitPrice) - Number(temp_open_price)) * tempSide * Number(this.rowData.open_interest) - Number(this.rowData.close_position_fee);
        tempValue = (0, _digital.floorNumber)(tempValue, 2);

        if (Number(tempValue) <= 0) {
          tempValue = "--";
        }
      } // inputProfitPrice


      return tempValue;
    },
    expectedProfitPercent: function expectedProfitPercent() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputProfitPrice != "" && Number(this.inputProfitPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndexPosition == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = ((this.inputProfitPrice - temp_open_price) * tempSide * this.rowData.open_interest - this.rowData.close_position_fee) / this.rowData.bail_number * 100;
        tempValue = (0, _digital.floorNumber)(tempValue, 2);

        if (Number(tempValue) <= 0) {
          tempValue = "--";
        } else {
          tempValue = "+" + tempValue;
        }
      } // inputProfitPrice


      return tempValue;
    },
    // 平仓盈亏 = (inputLossPrice-开仓价) × (1 做多 | -1做空)) × 持仓数量  - 平仓手续费
    expectedLoss: function expectedLoss() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputLossPrice != "" && Number(this.inputLossPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndexPosition == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = (this.inputLossPrice - temp_open_price) * tempSide * this.rowData.open_interest - this.rowData.close_position_fee;
        tempValue = (0, _digital.ceilNumber)(tempValue, 2); // tempValue = Math.ceil(tempValue * 100) / 100;

        if (Number(tempValue) < this.rowData.bail_number * -1) {
          tempValue = this.rowData.bail_number * -1;
        }

        if (Number(tempValue) > 0) {
          tempValue = "--";
        }
      } // inputLossPrice


      return tempValue;
    },
    expectedLossPercent: function expectedLossPercent() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputLossPrice != "" && Number(this.inputLossPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndexPosition == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = ((this.inputLossPrice - temp_open_price) * tempSide * this.rowData.open_interest - this.rowData.close_position_fee) / this.rowData.bail_number * 100;
        tempValue = (0, _digital.ceilNumber)(tempValue, 2);

        if (Number(tempValue) < -100) {
          tempValue = -100;
        }

        if (Number(tempValue) > 0) {
          tempValue = "--";
        }
      } // inputLossPrice


      return tempValue;
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.isDestoryWS = true;
    this.global.ws.close();
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    translateTitle: _i18n.translateTitle,
    parseTime: _index2.parseTime,
    onOpenOrderDetails: function onOpenOrderDetails(assets_type, row) {
      // this.currRow
      var tempRow = {
        order_info: {
          position_order_id: row.position_order_id
        },
        assets_type: assets_type
      };
      this.$refs.orderDetails.liquidationContractInfoClick(tempRow);
    },
    searchPlanOrderList: function searchPlanOrderList() {
      this.initData();
    },
    resetPlanOrderList: function resetPlanOrderList() {
      this.planOrderList_create_time = "";
      this.planOrderList_symbol_id = "";
      this.planOrderList_open_side = "";
      this.ctimeAndEtime = [];
      this.ctimeAndEtime4History = [];
      this.initData();
    },
    getItemList: function getItemList() {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$getCoinList, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _index4.getStaticCoinList)();

              case 2:
                _yield$getCoinList = _context2.sent;
                status = _yield$getCoinList.status;
                data = _yield$getCoinList.data;

                if (status == 200) {
                  _this5.coinData = data;
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getCoinInfoMap: function getCoinInfoMap() {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(13);

              case 2:
                _yield$apiGetStaticTa = _context3.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this6.coinInfoMap = data;
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getTradePairList: function getTradePairList() {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$apiGetStaticTa2, status, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(49);

              case 2:
                _yield$apiGetStaticTa2 = _context4.sent;
                status = _yield$apiGetStaticTa2.status;
                data = _yield$apiGetStaticTa2.data;

                if (status == 200) {
                  _this7.symbolList = data;
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onProfitPriceEdit: function onProfitPriceEdit(row) {
      this.rowData = row;
      this.row_swap_symbol_id = row.symbol_id;

      if (row.stop_profit_price != "--") {
        this.inputProfitPrice = row.stop_profit_price;
      } else {
        this.inputProfitPrice = "";
      }

      if (row.stop_loss_price != "--") {
        this.inputLossPrice = row.stop_loss_price;
      } else {
        this.inputLossPrice = "";
      }

      this.setProfitPricedialog = true;
    },
    onLossPriceEdit: function onLossPriceEdit(row) {
      this.rowData = row;
      this.row_swap_symbol_id = row.symbol_id;

      if (row.stop_profit_price != "--") {
        this.inputProfitPrice = row.stop_profit_price;
      } else {
        this.inputProfitPrice = "";
      }

      if (row.stop_loss_price != "--") {
        this.inputLossPrice = row.stop_loss_price;
      } else {
        this.inputLossPrice = "";
      }

      this.setProfitPricedialog = true;
    },
    onOpenAppendMoney: function onOpenAppendMoney(row) {
      this.from_item_id = row.open_item_id;
      this.to_item_id = row.settlement_item_id;
      this.from_symbol = this.coinInfoMap[row.open_item_id].item_name.toUpperCase();
      this.to_symbol = this.coinInfoMap[row.settlement_item_id].item_name.toUpperCase();
      this.swap_symbol_id = row.symbol_id;
      this.position_order_id = row.position_order_id;
      this.beforeBailNumber = row.bail_number;
      this.afterBailNumber = row.bail_number;
      this.beforeLiquidationPrice = row.liquidation_price;
      this.afterLiquidationPrice = row.liquidation_price;
      this.rowData = row;

      for (var key in this.symbolList) {
        if (key == row.symbol_id) {
          this.price_precision = this.symbolList[key].price_precision;
        }
      }

      this.appendMoneydialog = true;
    },
    onOpenConfirm: function onOpenConfirm(type, id) {
      this.dialogType = type;

      if (type == 1) {
        this.position_order_id = id;
        this.confirmMessage = this.translateTitle("是否确认平仓此订单？");
      } else if (type == 2) {
        this.confirmMessage = this.translateTitle("是否确认全部平仓？");
      } else if (type == 3) {
        this.confirmMessage = this.translateTitle("是否确认全部撤销？");
      } else if (type == 4) {
        this.plan_order_id = id;
        this.confirmMessage = this.translateTitle("是否确认撤销此委托单？");
      }

      this.dialogVisible = true;
    },
    // async onPositionChange(item) {
    //   this.currIndexPosition = item.value;
    // },
    //////////////////////////////////////
    onOK: function onOK() {
      if (this.dialogType == 1) {
        this.onClosePosition();
      } else if (this.dialogType == 2) {
        this.onCancelOrder();
      } else if (this.dialogType == 3) {
        this.onRevokeAllOrder();
      } else if (this.dialogType == 4) {
        this.onRevokePlan();
      }
    },
    goToRecharge: function goToRecharge() {
      window.open(this.routeSplicing(this.language, "ucenter/assets/recharge/usdt"));
    },
    onClearAll: function onClearAll() {
      this.inputProfitPrice = "";
    },
    onClearAllV2: function onClearAllV2() {
      this.inputLossPrice = "";
    },
    setProfitPricedialogClose: function setProfitPricedialogClose() {
      this.inputLossPrice = "";
      this.inputProfitPrice = "";
      this.setProfitPricedialog = false;
    },
    appendMoneydialogClose: function appendMoneydialogClose() {
      this.bail_number = "";
      this.appendMoneydialog = false;
    },
    onClickAll: function onClickAll() {
      this.bail_number = this.assetsInfoShow;
    },
    reset: function reset(type) {
      this.tableLoading = true;
      this.currIndexPosition = type.toString();
      this.pageInfo.pageCurrent = 1;
      this.initData(this.checked);
      this.getOrderNumber();
    },
    getAssets: function getAssets() {
      var _this8 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, _yield$apiGetAssets, status, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this8.userInfo) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                params = {
                  type: "all"
                };
                _context5.next = 5;
                return (0, _index.apiGetAssets)(params);

              case 5:
                _yield$apiGetAssets = _context5.sent;
                status = _yield$apiGetAssets.status;
                data = _yield$apiGetAssets.data;

                if (status == 200) {
                  _this8.apiAssetsInfo = data;
                }

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // onProfitPriceEdit(row) {
    //   this.rowData = row;
    //   this.row_swap_symbol_id = row.symbol_id;
    //   if (row.stop_profit_price != "--") {
    //     this.inputProfitPrice = row.stop_profit_price;
    //   } else {
    //     this.inputProfitPrice = "";
    //   }
    //   if (row.stop_loss_price != "--") {
    //     this.inputLossPrice = row.stop_loss_price;
    //   } else {
    //     this.inputLossPrice = "";
    //   }
    //   this.setProfitPricedialog = true;
    // },
    // onLossPriceEdit(row) {
    //   this.rowData = row;
    //   this.row_swap_symbol_id = row.symbol_id;
    //   if (row.stop_profit_price != "--") {
    //     this.inputProfitPrice = row.stop_profit_price;
    //   } else {
    //     this.inputProfitPrice = "";
    //   }
    //   if (row.stop_loss_price != "--") {
    //     this.inputLossPrice = row.stop_loss_price;
    //   } else {
    //     this.inputLossPrice = "";
    //   }
    //   this.setProfitPricedialog = true;
    // },
    // async getCoinInfoMap() {
    //   const { status, data } = await apiGetStaticTableInfo(13);
    //   if (status == 200) {
    //     this.coinInfoMap = data;
    //   }
    // },
    // async getTradePairList() {
    //   const { status, data } = await apiGetStaticTableInfo(49);
    //   if (status == 200) {
    //     this.symbolList = data;
    //   }
    // },
    onSymbolChange: function onSymbolChange(item) {
      this.$emit("on-symbol-change", item);
    },
    onSymbolClick: function onSymbolClick(row) {
      var tempName = "";

      if (row.from_symbol_name) {
        tempName = row.from_symbol_name.toLowerCase() + "usdt";
      } else {
        for (var key in this.coinInfoMap) {
          if (key == row.open_item_id) {
            tempName = this.coinInfoMap[key].item_name.toLowerCase() + "usdt";
          }
        }
      }

      window.open(this.routeSplicing(this.language, "contract-exchange/" + tempName));
    },
    // onOpenConfirm(type, id) {
    //   this.dialogType = type;
    //   if (type == 1) {
    //     this.position_order_id = id;
    //     this.confirmMessage = this.translateTitle("是否确认平仓此订单？");
    //   } else if (type == 2) {
    //     this.confirmMessage = this.translateTitle("是否确认全部平仓？");
    //   } else if (type == 3) {
    //     this.confirmMessage = this.translateTitle("是否确认全部撤销？");
    //   } else if (type == 4) {
    //     this.plan_order_id = id;
    //     this.confirmMessage = this.translateTitle("是否确认撤销此委托单？");
    //   }
    //   this.dialogVisible = true;
    // },
    // onOpenAppendMoney(row) {
    //   this.position_order_id = row.position_order_id;
    //   this.beforeBailNumber = row.bail_number;
    //   this.afterBailNumber = row.bail_number;
    //   this.beforeLiquidationPrice = row.liquidation_price;
    //   this.afterLiquidationPrice = row.liquidation_price;
    //   this.rowData = row;
    //   for (const key in this.symbolList) {
    //     if (key == row.symbol_id) {
    //       this.price_precision = this.symbolList[key].price_precision;
    //     }
    //   }
    //   this.appendMoneydialog = true;
    // },
    onClosePosition: function onClosePosition() {
      var _this9 = this;

      var params = {
        position_order_id: this.position_order_id
      };
      (0, _order.apiClosePosition)(params).then(function (res) {
        if (res.status == 200) {
          _this9.dialogVisible = false;
          (0, _message.showMessage)({
            message: _this9.translateTitle("平仓成功"),
            type: "success" // duration:10000000,

          });

          _this9.initData(_this9.checked);
        }
      });
    },
    onAppendMoney: function onAppendMoney() {
      var _this10 = this;

      if (Number(this.bail_number) == 0) {
        (0, _message.showMessage)({
          message: this.translateTitle("请输入追加金额"),
          type: "error"
        });
        return;
      }

      var params = {
        position_order_id: this.position_order_id,
        bail_number: this.bail_number
      };
      (0, _order.apiAppendInterest)(params).then(function (res) {
        if (res.status == 200) {
          (0, _message.showMessage)({
            message: _this10.translateTitle("追加成功"),
            type: "success"
          });
          _this10.appendMoneydialog = false;

          _this10.initData(_this10.checked);
        }
      });
    },
    startTimer: function startTimer() {
      var _this11 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var timer;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                timer = setTimeout(function () {
                  _this11.loopData(_this11.checked); // this.initData(this.checked);
                  // this.getOrderNumber();
                  // this.getMultipleNum();


                  _this11.startTimer();
                }, 3000);

                _this11.$once("hook:beforeDestroy", function () {
                  clearTimeout(timer);
                });

                _this11.$once("hook:destroyed", function () {
                  clearTimeout(timer);
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onCancelOrder: function onCancelOrder() {
      var _this12 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _yield$apiAllClosePos, status, data;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return (0, _order.apiAllClosePosition)();

              case 2:
                _yield$apiAllClosePos = _context7.sent;
                status = _yield$apiAllClosePos.status;
                data = _yield$apiAllClosePos.data;

                if (status == 200) {
                  _this12.dialogVisible = false;
                  (0, _message.showMessage)({
                    message: _this12.translateTitle("平仓成功"),
                    type: "success"
                  });

                  _this12.initData(_this12.checked);
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    onRevokeAllOrder: function onRevokeAllOrder() {
      var _this13 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _yield$apiRevokeAllPl, status, data;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return (0, _order.apiRevokeAllPlan)();

              case 2:
                _yield$apiRevokeAllPl = _context8.sent;
                status = _yield$apiRevokeAllPl.status;
                data = _yield$apiRevokeAllPl.data;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this13.translateTitle("撤销成功"),
                    type: "success"
                  });
                  _this13.dialogVisible = false;

                  _this13.initData(_this13.checked);
                }

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    onRevokePlan: function onRevokePlan() {
      var _this14 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var req, _yield$apiRevokePlan, status, data;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                req = {
                  plan_order_id: _this14.plan_order_id
                };
                _context9.next = 3;
                return (0, _order.apiRevokePlan)(req);

              case 3:
                _yield$apiRevokePlan = _context9.sent;
                status = _yield$apiRevokePlan.status;
                data = _yield$apiRevokePlan.data;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this14.translateTitle("撤销成功"),
                    type: "success"
                  });
                  _this14.dialogVisible = false;

                  _this14.initData(_this14.checked);
                }

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    onSetPositionProfitLoss: function onSetPositionProfitLoss() {
      var _this15 = this;

      // if (this.inputLossPrice == "" && this.inputProfitPrice == "") {
      //   showMessage({ message: "请输入止盈价或止损价", type: "error" });
      //   return;
      // }
      if (this.currIndexPosition == 1) {
        var params = {
          position_order_id: this.rowData.position_order_id,
          market_price: this.rowMarketInfoShow.last,
          stop_profit_price: this.inputProfitPrice,
          stop_loss_price: this.inputLossPrice
        };
        (0, _order.apiSetPositionProfitLoss)(params).then(function (res) {
          if (res.status == 200) {
            (0, _message.showMessage)({
              message: _this15.translateTitle("设置成功"),
              type: "success"
            });

            _this15.setProfitPricedialogClose();

            _this15.initData(_this15.checked);
          }
        });
      } else {
        var _params = {
          plan_order_id: this.rowData.plan_order_id,
          market_price: this.rowMarketInfoShow.last,
          stop_profit_price: this.inputProfitPrice,
          stop_loss_price: this.inputLossPrice
        };
        (0, _order.apiSetPlanProfitLoss)(_params).then(function (res) {
          if (res.status == 200) {
            (0, _message.showMessage)({
              message: _this15.translateTitle("设置成功"),
              type: "success"
            });

            _this15.setProfitPricedialogClose();

            _this15.initData(_this15.checked);
          }
        });
      }
    },
    onPositionChange: function onPositionChange(item) {
      this.tableLoading = true;
      this.tableData = [];
      this.currIndexPosition = item.value;
      this.pageInfo.pageCurrent = 1;
      this.initData(this.checked);
    },
    getMultipleNum: function getMultipleNum() {
      var _this16 = this;

      if (!this.userInfo) {
        return;
      }

      var params = {
        symbol_id: this.checked ? this.swap_symbol_id : ""
      };
      (0, _order.apiGetOrderStatistic)(params).then(function (res) {
        if (res.status == 200) {
          _this16.contract_multiple_num = JSON.stringify(res.data.contract_multiple_num);
          localStorage.setItem("contract-multiple-num", _this16.contract_multiple_num);
          _this16.contract_position_num = res.data.contract_position_info.total_num;
          _this16.contract_plan_num = res.data.contract_plan_info.total_num;
        }
      });
    },
    getOrderNumber: function getOrderNumber() {
      var _this17 = this;

      if (!this.userInfo) {
        return;
      }

      var params = {
        symbol_id: this.checked ? this.swap_symbol_id : ""
      };
      (0, _order.apiGetOrderStatistic)(params).then(function (res) {
        if (res.status == 200) {
          _this17.contract_position_num = res.data.contract_position_info.total_num;
          _this17.contract_plan_num = res.data.contract_plan_info.total_num;
        }
      });
    },
    statisticAndFundingRate: function statisticAndFundingRate(data) {
      this.$emit("changeFundingRate", {
        fundForm: data.fundingRate,
        fundTime: data.fundingRate.time
      });
      this.contract_multiple_num = JSON.stringify(data.statistic.contract_multiple_num);
      localStorage.setItem("contract-multiple-num", this.contract_multiple_num);
      this.contract_position_num = data.statistic.contract_position_info.total_num;
      this.contract_plan_num = data.statistic.contract_plan_info.total_num;
    },
    loopData: function loopData() {
      var _arguments = arguments,
          _this18 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var checked, _yield$Account$getUse2, userInfo, params, _yield$apiGetContract, status, data, tempStatus, temp_symbol_id, temp_is_hide, req, _req, temp_order_status, _req2, _req3;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                checked = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;

                if (_this18.swap_symbol_id) {
                  _context10.next = 4;
                  break;
                }

                _this18.tableLoading = false;
                return _context10.abrupt("return");

              case 4:
                _context10.next = 6;
                return Account.getUserInfo();

              case 6:
                _yield$Account$getUse2 = _context10.sent;
                userInfo = _yield$Account$getUse2.userInfo;

                if (userInfo) {
                  _context10.next = 19;
                  break;
                }

                if (!_this18.swap_symbol_id) {
                  _context10.next = 17;
                  break;
                }

                params = {
                  module: "fundingRate",
                  "fundingRate-symbol_id": _this18.swap_symbol_id
                };
                _context10.next = 13;
                return (0, _order.apiGetContract)(params);

              case 13:
                _yield$apiGetContract = _context10.sent;
                status = _yield$apiGetContract.status;
                data = _yield$apiGetContract.data;

                if (status == 200) {
                  _this18.$emit("changeFundingRate", {
                    fundForm: data.fundingRate,
                    fundTime: data.fundingRate.time
                  });
                }

              case 17:
                _this18.tableLoading = false;
                return _context10.abrupt("return");

              case 19:
                tempStatus = _this18.currIndex;

                if (_this18.currIndexPosition == 3) {
                  tempStatus = "";
                }

                temp_symbol_id = _this18.swap_symbol_id;
                temp_is_hide = 2;

                if (checked) {
                  temp_symbol_id = _this18.swap_symbol_id;
                  temp_is_hide = 1;
                } else {
                  temp_symbol_id = "";
                  temp_is_hide = 2;
                }

                if (!(_this18.currIndexPosition == 1)) {
                  _context10.next = 29;
                  break;
                }

                req = {
                  module: "fundingRate,openPositionList,statistic",
                  "openPositionList-symbol_id": temp_symbol_id,
                  "openPositionList-position_status": 1,
                  "openPositionList-page": _this18.pageInfo.pageCurrent,
                  "openPositionList-page_size": _this18.pageInfo.pageSize,
                  "statistic-symbol_id": _this18.checked ? _this18.swap_symbol_id : "",
                  "fundingRate-symbol_id": _this18.swap_symbol_id // is_hide: temp_is_hide,

                }; //  return apiGetOpenPositionList(req).then((res) => {

                return _context10.abrupt("return", (0, _order.apiGetContract)(req).then(function (res) {
                  if (res.status == 200) {
                    _this18.statisticAndFundingRate(res.data);
                  }

                  if (res.status == 200 && res.data.openPositionList && res.data.openPositionList.list.length > 0) {
                    res.data.openPositionList.list.forEach(function (ele) {
                      // 存各个币种杠杆倍数
                      _this18.contractMultipleNum[ele.symbol_id] = {
                        open_leverage: ele.open_leverage
                      }; // 持仓盈亏 = (市价-开仓价) × (1 做多 | -1做空)) × 持仓数量

                      // 持仓盈亏 = (市价-开仓价) × (1 做多 | -1做空)) × 持仓数量
                      _this18.marketList.forEach(function (item) {
                        if (item.symbol_id == ele.symbol_id) {
                          ele.last_price = item.last;
                        }
                      });

                      var tempSide = ele.open_side == 1 ? 1 : -1; // 未实现盈亏

                      // 未实现盈亏
                      ele.position_profit_loss = (ele.last_price - ele.open_price) * tempSide * ele.open_interest;
                      ele.position_profit_loss_procent = ((ele.last_price - ele.open_price) * tempSide * ele.open_interest / ele.bail_number * 100).toFixed(2);

                      for (var key in _this18.coinInfoMap) {
                        if (key == ele.open_item_id) {
                          ele.from_symbol_name = _this18.coinInfoMap[key].item_name.toUpperCase();
                        }
                      }

                      ele.to_symbol = _this18.coinInfoMap[ele.settlement_item_id] && _this18.coinInfoMap[ele.settlement_item_id].item_name.toUpperCase();
                    });
                    _this18.tableData = res.data.openPositionList.list;
                    _this18.pageInfo = res.data.openPositionList.pageInfo;
                  } else {
                    _this18.tableData = [];
                    _this18.tableLoading = false;
                  }

                  _this18.tableLoading = false;
                }));

              case 29:
                if (!(_this18.currIndexPosition == 2)) {
                  _context10.next = 34;
                  break;
                }

                _req = {
                  module: "fundingRate,planOrderList,statistic",
                  "planOrderList-symbol_id": temp_symbol_id,
                  "planOrderList-order_status": 1,
                  "planOrderList-is_hide": 2,
                  "planOrderList-page": _this18.pageInfo.pageCurrent,
                  "planOrderList-page_size": _this18.pageInfo.pageSize,
                  "statistic-symbol_id": _this18.checked ? _this18.swap_symbol_id : "",
                  "fundingRate-symbol_id": _this18.swap_symbol_id
                }; // return apiGetPlanOrderList(req).then((res) => {

                return _context10.abrupt("return", (0, _order.apiGetContract)(_req).then(function (res) {
                  if (res.status == 200) {
                    _this18.statisticAndFundingRate(res.data);

                    var _loop = function _loop(key) {
                      res.data.planOrderList.list.forEach(function (ele) {
                        _this18.marketList.forEach(function (item) {
                          if (item.symbol_id == ele.symbol_id) {
                            ele.last_price = item.last;
                          }
                        });

                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this18.exchangeCoinMap[key].name.toUpperCase();
                        }

                        ele.to_symbol = _this18.coinInfoMap[ele.settlement_item_id] && _this18.coinInfoMap[ele.settlement_item_id].item_name.toUpperCase();
                      });
                    };

                    for (var key in _this18.exchangeCoinMap) {
                      _loop(key);
                    }

                    _this18.tableData = res.data.planOrderList.list;
                    _this18.pageInfo = res.data.planOrderList.pageInfo;
                  } else {
                    _this18.tableLoading = false;
                  }

                  _this18.tableLoading = false;
                }));

              case 34:
                if (!(_this18.currIndexPosition == 3)) {
                  _context10.next = 41;
                  break;
                }

                temp_order_status = "2,3,4";

                if (_this18.hidenCancelChecked) {
                  temp_order_status = "2,4";
                } else {
                  temp_order_status = "2,3,4";
                }

                _req2 = {
                  module: "fundingRate,planOrderList,statistic",
                  "planOrderList-symbol_id": temp_symbol_id,
                  "planOrderList-order_status": temp_order_status,
                  "planOrderList-is_hide": 2,
                  "planOrderList-page": _this18.pageInfo.pageCurrent,
                  "planOrderList-page_size": _this18.pageInfo.pageSize,
                  "statistic-symbol_id": _this18.checked ? _this18.swap_symbol_id : "",
                  "fundingRate-symbol_id": _this18.swap_symbol_id
                }; // return apiGetPlanOrderList(req).then((res) => {

                return _context10.abrupt("return", (0, _order.apiGetContract)(_req2).then(function (res) {
                  if (res.status == 200) {
                    _this18.statisticAndFundingRate(res.data);

                    res.data.planOrderList.list.forEach(function (ele) {
                      for (var key in _this18.exchangeCoinMap) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this18.exchangeCoinMap[key].name.toUpperCase();
                        }
                      }

                      for (var _key in _this18.coinInfoMap) {
                        if (_key == ele.open_item_id) {
                          ele.from_symbol_name = _this18.coinInfoMap[_key].item_name.toUpperCase();
                        }

                        if (_key == ele.settlement_item_id) {
                          ele.to_symbol_name = _this18.coinInfoMap[_key].item_name.toUpperCase();
                        }
                      }

                      ele.to_symbol = _this18.coinInfoMap[ele.settlement_item_id] && _this18.coinInfoMap[ele.settlement_item_id].item_name.toUpperCase();
                    });
                    _this18.tableData = res.data.planOrderList.list;
                    _this18.pageInfo = res.data.planOrderList.pageInfo;
                  } else {
                    _this18.tableLoading = false;
                  }

                  _this18.tableLoading = false;
                }));

              case 41:
                if (!(_this18.currIndexPosition == 4)) {
                  _context10.next = 44;
                  break;
                }

                _req3 = {
                  module: "fundingRate,openPositionList,statistic",
                  "openPositionList-symbol_id": temp_symbol_id,
                  "openPositionList-position_status": 2,
                  "openPositionList-page": _this18.pageInfo.pageCurrent,
                  "openPositionList-page_size": _this18.pageInfo.pageSize,
                  "statistic-symbol_id": _this18.checked ? _this18.swap_symbol_id : "",
                  "fundingRate-symbol_id": _this18.swap_symbol_id
                }; // return apiGetOpenPositionList(req).then((res) => {

                return _context10.abrupt("return", (0, _order.apiGetContract)(_req3).then(function (res) {
                  if (res.status == 200) {
                    _this18.statisticAndFundingRate(res.data);
                  }

                  if (res.status == 200 && res.data.openPositionList && res.data.openPositionList.list.length > 0) {
                    res.data.openPositionList.list.forEach(function (ele) {
                      for (var key in _this18.exchangeCoinMap) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this18.exchangeCoinMap[key].name.toUpperCase();
                        }
                      }

                      for (var _key2 in _this18.coinInfoMap) {
                        if (_key2 == ele.open_item_id) {
                          ele.from_symbol_name = _this18.coinInfoMap[_key2].item_name.toUpperCase();
                        }
                      }

                      ele.to_symbol = _this18.coinInfoMap[ele.settlement_item_id] && _this18.coinInfoMap[ele.settlement_item_id].item_name.toUpperCase();
                    });
                    _this18.tableData = res.data.openPositionList.list;
                    _this18.pageInfo = res.data.openPositionList.pageInfo;
                  } else {
                    _this18.tableData = [];
                    _this18.tableLoading = false;
                  }

                  _this18.tableLoading = false;
                }));

              case 44:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    initData: function initData() {
      var _arguments2 = arguments,
          _this19 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var checked, _yield$Account$getUse3, userInfo, tempStatus, temp_symbol_id, temp_is_hide, req, _req4, temp_order_status, create_time, end_time, _this19$ctimeAndEtime, start, end, end2, _req5, _create_time, _end_time, _this19$ctimeAndEtime2, _start, _end, _end2, _req6;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                checked = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;
                // if (!this.swap_symbol_id) {
                //   this.tableLoading = false;
                //   return;
                // }
                _this19.tableLoading = true;
                _context11.next = 4;
                return Account.getUserInfo();

              case 4:
                _yield$Account$getUse3 = _context11.sent;
                userInfo = _yield$Account$getUse3.userInfo;

                if (userInfo) {
                  _context11.next = 9;
                  break;
                }

                _this19.tableLoading = false;
                return _context11.abrupt("return");

              case 9:
                tempStatus = _this19.currIndex;

                if (_this19.currIndexPosition == 3) {
                  tempStatus = "";
                }

                temp_symbol_id = _this19.swap_symbol_id;
                temp_is_hide = 2;

                if (checked) {
                  temp_symbol_id = _this19.swap_symbol_id;
                  temp_is_hide = 1;
                } else {
                  temp_symbol_id = "";
                  temp_is_hide = 2;
                }

                if (!(_this19.currIndexPosition == 1)) {
                  _context11.next = 19;
                  break;
                }

                req = {
                  symbol_id: temp_symbol_id,
                  position_status: 1,
                  page: _this19.pageInfo.pageCurrent,
                  page_size: 100000 // page_size: this.pageInfo.pageSize,
                  // is_hide: temp_is_hide,

                };
                return _context11.abrupt("return", (0, _order.apiGetOpenPositionList)(req).then(function (res) {
                  if (res.status == 200 && res.data.list.length > 0) {
                    res.data.list.forEach(function (ele) {
                      // 存各个币种杠杆倍数
                      _this19.contractMultipleNum[ele.symbol_id] = {
                        open_leverage: ele.open_leverage
                      }; // 持仓盈亏 = (市价-开仓价) × (1 做多 | -1做空)) × 持仓数量

                      // 持仓盈亏 = (市价-开仓价) × (1 做多 | -1做空)) × 持仓数量
                      _this19.marketList.forEach(function (item) {
                        if (item.symbol_id == ele.symbol_id) {
                          ele.last_price = item.last;
                        }
                      });

                      var tempSide = ele.open_side == 1 ? 1 : -1; // 未实现盈亏

                      // 未实现盈亏
                      ele.position_profit_loss = (ele.last_price - ele.open_price) * tempSide * ele.open_interest;
                      ele.position_profit_loss_procent = ((ele.last_price - ele.open_price) * tempSide * ele.open_interest / ele.bail_number * 100).toFixed(2);

                      for (var key in _this19.coinInfoMap) {
                        if (key == ele.open_item_id) {
                          ele.from_symbol_name = _this19.coinInfoMap[key].item_name.toUpperCase();
                        }
                      }

                      ele.to_symbol = _this19.coinInfoMap[ele.settlement_item_id] && _this19.coinInfoMap[ele.settlement_item_id].item_name.toUpperCase();
                    });
                    _this19.tableData = res.data.list; // this.pageInfo = res.data.pageInfo;
                  } else {
                    _this19.tableData = [];
                    _this19.tableLoading = false;
                  }

                  _this19.tableLoading = false;
                }));

              case 19:
                if (!(_this19.currIndexPosition == 2)) {
                  _context11.next = 24;
                  break;
                }

                _req4 = {
                  symbol_id: temp_symbol_id,
                  order_status: 1,
                  is_hide: 2,
                  page: _this19.pageInfo.pageCurrent,
                  page_size: 100000 // page_size: this.pageInfo.pageSize,

                };
                return _context11.abrupt("return", (0, _order.apiGetPlanOrderList)(_req4).then(function (res) {
                  if (res.status == 200) {
                    res.data.list.forEach(function (ele) {
                      ele.to_symbol = _this19.coinInfoMap[ele.settlement_item_id] && _this19.coinInfoMap[ele.settlement_item_id].item_name.toUpperCase();
                    });

                    var _loop2 = function _loop2(key) {
                      res.data.list.forEach(function (ele) {
                        _this19.marketList.forEach(function (item) {
                          if (item.symbol_id == ele.symbol_id) {
                            ele.last_price = item.last;
                          }
                        });

                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this19.exchangeCoinMap[key].name.toUpperCase();
                        }
                      });
                    };

                    for (var key in _this19.exchangeCoinMap) {
                      _loop2(key);
                    }

                    _this19.tableData = res.data.list; // this.pageInfo = res.data.pageInfo;
                  } else {
                    _this19.tableLoading = false;
                  }

                  _this19.tableLoading = false;
                }));

              case 24:
                if (!(_this19.currIndexPosition == 3)) {
                  _context11.next = 34;
                  break;
                }

                temp_order_status = "2,3,4";

                if (_this19.hidenCancelChecked) {
                  temp_order_status = "2,4";
                } else {
                  temp_order_status = "2,3,4";
                } // let temp_create_time = "";
                // if (this.planOrderList_create_time) {
                //   temp_create_time =
                //     Date.parse(new Date()) / 1000 - this.planOrderList_create_time;
                // }


                create_time = "";
                end_time = "";

                if (_this19.ctimeAndEtime4History) {
                  _this19$ctimeAndEtime = (0, _slicedToArray2.default)(_this19.ctimeAndEtime4History, 2), start = _this19$ctimeAndEtime[0], end = _this19$ctimeAndEtime[1];
                  end2 = end + 86399000;
                  create_time = parseInt(start / 1000);
                  end_time = parseInt(end2 / 1000);
                }

                _req5 = {
                  symbol_id: _this19.planOrderList_symbol_id,
                  open_side: _this19.planOrderList_open_side,
                  create_time: create_time,
                  end_time: end_time,
                  // create_time: temp_create_time,
                  order_status: temp_order_status,
                  is_hide: 2,
                  page: _this19.pageInfo.pageCurrent,
                  page_size: _this19.pageInfo.pageSize
                };
                return _context11.abrupt("return", (0, _order.apiGetPlanOrderList)(_req5).then(function (res) {
                  if (res.status == 200) {
                    res.data.list.forEach(function (ele) {
                      for (var key in _this19.exchangeCoinMap) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this19.exchangeCoinMap[key].name.toUpperCase();
                        }
                      }

                      for (var _key3 in _this19.coinInfoMap) {
                        if (_key3 == ele.open_item_id) {
                          ele.from_symbol_name = _this19.coinInfoMap[_key3].item_name.toUpperCase();
                        }

                        if (_key3 == ele.settlement_item_id) {
                          ele.to_symbol_name = _this19.coinInfoMap[_key3].item_name.toUpperCase();
                        }
                      }

                      ele.to_symbol = _this19.coinInfoMap[ele.settlement_item_id] && _this19.coinInfoMap[ele.settlement_item_id].item_name.toUpperCase();
                    });
                    _this19.tableData = res.data.list;
                    _this19.pageInfo = res.data.pageInfo;
                  } else {
                    _this19.tableLoading = false;
                  }

                  _this19.tableLoading = false;
                }));

              case 34:
                if (!(_this19.currIndexPosition == 4)) {
                  _context11.next = 40;
                  break;
                }

                // let temp_creat_time = "";
                // if (this.planOrderList_create_time) {
                //   temp_creat_time =
                //     Date.parse(new Date()) / 1000 - this.planOrderList_create_time;
                // }
                _create_time = "";
                _end_time = "";

                if (_this19.ctimeAndEtime) {
                  _this19$ctimeAndEtime2 = (0, _slicedToArray2.default)(_this19.ctimeAndEtime, 2), _start = _this19$ctimeAndEtime2[0], _end = _this19$ctimeAndEtime2[1];
                  _end2 = _end + 86399000;
                  _create_time = parseInt(_start / 1000);
                  _end_time = parseInt(_end2 / 1000);
                }

                _req6 = {
                  symbol_id: _this19.planOrderList_symbol_id,
                  open_side: _this19.planOrderList_open_side,
                  create_time: _create_time,
                  end_time: _end_time,
                  position_status: 2,
                  page: _this19.pageInfo.pageCurrent,
                  page_size: _this19.pageInfo.pageSize
                };
                return _context11.abrupt("return", (0, _order.apiGetOpenPositionList)(_req6).then(function (res) {
                  if (res.status == 200 && res.data.list.length > 0) {
                    res.data.list.forEach(function (ele) {
                      for (var key in _this19.exchangeCoinMap) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this19.exchangeCoinMap[key].name.toUpperCase();
                        }
                      }

                      for (var _key4 in _this19.coinInfoMap) {
                        if (_key4 == ele.open_item_id) {
                          ele.from_symbol_name = _this19.coinInfoMap[_key4].item_name.toUpperCase();
                        }
                      }

                      ele.to_symbol = _this19.coinInfoMap[ele.settlement_item_id] && _this19.coinInfoMap[ele.settlement_item_id].item_name.toUpperCase();
                    });
                    _this19.tableData = res.data.list;
                    _this19.pageInfo = res.data.pageInfo;
                  } else {
                    _this19.tableData = [];
                    _this19.tableLoading = false;
                  }

                  _this19.tableLoading = false;
                }));

              case 40:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    onPageChange: function onPageChange() {
      this.initData(this.checked);
    },
    initURL: function initURL() {
      var _this20 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var params, _yield$apiWsUrl, status, data;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                params = {
                  __version: "3.4.3" // token: this.token,

                };
                _context12.next = 3;
                return (0, _index3.apiWsUrl)(params);

              case 3:
                _yield$apiWsUrl = _context12.sent;
                status = _yield$apiWsUrl.status;
                data = _yield$apiWsUrl.data;

                if (status == 200) {
                  _this20.wsUrl = data.ws3_url;
                }

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    initWs: function initWs() {
      var me = this;
      var option = {
        url: this.wsUrl,
        subData: {
          action: "Topic.sub",
          data: {
            type: "contractM",
            app_id: _stationSetting.VUE_APP_ID
          } // action: "Topic.sub",
          // data: {
          //   type: "kline",
          //   resolution: "15",
          //   symbol: me.swap_symbol_id,
          // },

        },
        callback: callback,
        onConnect: onConnect,
        mounted: mounted
      };
      var wsNew = new _socket.default(option).getInstance();
      me.global.setWs(wsNew); // 重新连接

      function onConnect() {
        if (me.isDestoryWS) return;
        if (me.lockReconnect) return;

        if (me.wsContentTime > 3) {
          window.location.reload();
        }

        me.lockReconnect = true;
        me.tt && clearTimeout(me.tt);
        me.tt = setTimeout(function () {
          me.wsContentTime++;
          console.log("ws重連");
          me.initWs();
          me.lockReconnect = false;
        }, 3000);
      }

      function mounted() {
        // window.ws.sub({
        //   action: "Topic.sub",
        //   data: {
        //     type: "depth",
        //     symbol: me.swap_symbol_id,
        //     // resolution: "D",
        //   },
        // });
        // window.ws.sub({
        //   action: "Topic.sub",
        //   data: {
        //     type: "orderbook",
        //     symbol: me.swap_symbol_id,
        //   },
        // });
        // window.ws.sub({
        //   action: "Topic.sub",
        //   data: {
        //     type: "contractM",
        //     app_id: VUE_APP_ID,
        //   },
        // });
        if (_jsCookie.default.get("topcredit_exchange_t")) {
          me.global.ws.sub({
            action: "Topic.sub",
            data: {
              type: "assets"
            }
          });
        }
      }

      function callback(data) {
        var action = data.action;

        if (action == "Pushdata.contractM") {
          if (data.data) {
            var tempArr = data.data;
            tempArr.forEach(function (ele) {
              ele.lastV2 = Number(ele.last);
              ele.currency.usdV2 = Number(ele.usd);
              ele.price_change_percentV2 = Number(ele.price_change_percent);
            });
            me.marketList = tempArr;
          }
        } // if (action == "Pushdata.kline") {
        //   window.resolveKlineDataV2(data);
        // }
        // // 资产


        if (action == "Pushdata.assets") {
          if (data.data == null || data.data instanceof Array) {
            return;
          }

          me.assetsInfo = data.data;
        } // if (action == "Pushdata.orderbook") {
        //   if (data.data) {
        //     if (!data.params.p || data.params.p == me.old_swap_symbol_id) {
        //       return;
        //     }
        //     me.orderbookList.unshift(...data.data);
        //     if (me.orderbookList.length > 28) {
        //       me.orderbookList = me.orderbookList.slice(0, 28);
        //     }
        //   }
        // }
        // if (action == "Pushdata.depth") {
        //   if (data.data) {
        //     if (!data.params.p || data.params.p == me.old_swap_symbol_id) {
        //       return;
        //     }
        //     let tempObj = data.data;
        //     if (tempObj.a.length > 0) {
        //       tempObj.c = 0;
        //       tempObj.d = 0;
        //       tempObj.a.forEach((ele) => {
        //         tempObj.c += Number(ele[1]);
        //       });
        //       tempObj.b.forEach((ele) => {
        //         tempObj.d += Number(ele[1]);
        //       });
        //     }
        //     me.depthList = tempObj;
        //   }
        // }

      }
    }
  },
  watch: {
    // swap_symbol_id: {
    //   handler(newVal, oldVal) {
    //     if (oldVal == undefined) {
    //       return;
    //     }
    //     if (newVal != oldVal) {
    //       this.symbolId = newVal;
    //       this.orderLoading = true;
    //       this.pageInfo.pageCurrent = 1;
    //       this.initData(this.checked);
    //     }
    //   },
    // },
    hidenCancelChecked: function hidenCancelChecked() {
      this.initData(this.checked);
      this.getOrderNumber();
    },
    checked: function checked() {
      this.initData(this.checked);
      this.getOrderNumber();
    },
    marketList: function marketList() {
      var _this21 = this;

      if (this.currIndexPosition == 1 || this.currIndexPosition == 2) {
        this.tableData.forEach(function (ele) {
          _this21.marketList.forEach(function (item) {
            if (item.symbol_id == ele.symbol_id) {
              ele.last_price = item.last;
            }
          });

          var tempSide = ele.open_side == 1 ? 1 : -1; // 未实现盈亏

          ele.position_profit_loss = (ele.last_price - ele.open_price) * tempSide * ele.open_interest;
          ele.position_profit_loss_procent = ((ele.last_price - ele.open_price) * tempSide * ele.open_interest / ele.bail_number * 100).toFixed(2);
        });
      }
    }
  }
};
exports.default = _default;